import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=5f72b720&"
import script from "./channelList.vue?vue&type=script&lang=js&"
export * from "./channelList.vue?vue&type=script&lang=js&"
import style0 from "./channelList.vue?vue&type=style&index=0&id=5f72b720&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports